const singleWork = () => {
  const breadItems = document.querySelectorAll('.breadcrumb-list__item');
  const homeUrl = document.querySelector('body').dataset.homeUrl;
  if (breadItems.length > 0) {
    breadItems.forEach((item) => {
      const child = item.querySelector('a, span');
      if (child.innerText === '施工事例・お客様の声') {
        const aTag = document.createElement('a');
        aTag.setAttribute('href', homeUrl + 'work/');
        aTag.innerText = '施工事例・お客様の声';
        item.innerHTML = '';
        item.appendChild(aTag);
      }
    });
  }
};

export default singleWork;
